// Line-item money math — mirrors backend main/smartbill.py::calc_totals and the
// inline totals in FacturaModal. Amounts are returned in the line's own currency;
// multiply by the document's curs_valutar for RON.

export function lineAmounts(p) {
  const qty     = parseFloat(p.quantity) || 0;
  const price   = parseFloat(p.price) || 0;
  const tvaRate = (parseFloat(p.taxPercentage) || 0) / 100;
  const unitNet = p.isTaxIncluded ? price / (1 + tvaRate) : price;
  const net     = unitNet * qty;
  const tva     = net * tvaRate;
  return { net, tva, gross: net + tva };
}

export function lineAmountsRon(p, curs) {
  const c = parseFloat(curs) || 1;
  const { net, tva, gross } = lineAmounts(p);
  return { netRon: net * c, tvaRon: tva * c, grossRon: gross * c };
}

// Per-line service type, with fallback for invoices created before the field
// existed: use the invoice-level tip_serviciu when it is unambiguous.
export function resolveLineTip(line, doc) {
  const t = (line && line.tip_serviciu) || '';
  if (t === 'taxe' || t === 'onorariu') return t;
  const docT = doc && doc.tip_serviciu;
  if (docT === 'taxe' || docT === 'onorariu') return docT;
  return 'nespecificat';
}

export const OBJ_SVC_LABEL = {
  taxe:         'Taxe',
  onorariu:     'Onorariu',
  nespecificat: 'Nespecificat',
};
